import React from 'react';

const SQUAD_BADGE_CLASS = {
  'Estrategia': 'badge--estrategia',
  'Criacao': 'badge--criacao',
  'Social & Comunidade': 'badge--social',
  'Trafego Pago': 'badge--trafego',
  'Producao': 'badge--producao',
};

function AgentCard({ agent, showSquad = false }) {
  return (
    <div className="card">
      <div className="agent-card">
        <div className="agent-icon">{agent.icon}</div>
        <div className="agent-info">
          <div className="agent-name">{agent.name}</div>
          <div className="agent-title">{agent.title}</div>
          <div className="agent-id">@{agent.id}</div>
        </div>
        {showSquad && (
          <span className={`badge ${SQUAD_BADGE_CLASS[agent.squad] || 'badge--accent'}`}>
            {agent.squad}
          </span>
        )}
      </div>
    </div>
  );
}

export default AgentCard;
